import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig } from 'ng-formly';
import { evalExpression } from 'ng-formly/src/core/utils';
import { LoopBackFilter, Entity, Entityfield, Entityrecord } from '../../../sdk/models';
import { AccountApi, EntityApi, EntityfieldApi, EntityrecordApi } from '../../../sdk/services/custom';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import * as _ from 'lodash';
import { EntityService } from '../../../services/entity.service';
import { ValidationService } from '../../../services/validation.service';
import { CacheService } from 'ng2-cache/ng2-cache';
import { PlatformApp } from '../../../services/app.service';
import { WindowRef } from '../../../services/window.service';
import { NotificationsService } from 'angular2-notifications';


@Component({
    selector: 'entityrecord-edit-button',
    templateUrl: './entityrecord-edit-button.component.html',
    providers: [EntityrecordApi, EntityApi],
    styleUrls: ['./entityrecord-edit-button.component.scss']

})

export class EntityRecordEditButtonComponent implements OnInit, OnDestroy {
    @Input() entityid: string;
    @Input() entityrecordid: string;
    @Input() entityrecord: Entityrecord = new Entityrecord();
    @Input() parentId: string;
    @Input() showEntityLabel: string = "true";
    @Input() buttontext: string;
    @Input() editable: string = "true";
    @Input() showTextOnly: string = "false";
    @Input() gotodetailpage: string = "false";
    @Input() addrecord: string = "false";
    @Input() dataprovider: any;

    @Output() onChanged: EventEmitter<Entityrecord> = new EventEmitter(true);

    filter: LoopBackFilter = <LoopBackFilter>{};
    currentuser: any;
    entity: Entity = new Entity();
    entityRecord: Entityrecord = new Entityrecord();
    fullEntityRecord: Entityrecord = new Entityrecord();
    entityDataFields: Array<Entityfield> = [];
    entityFormFields: Array<FormlyFieldConfig> = [];

    // Form Related
    formErrors = [];
    // private formValid = true;
    get formValid() { return this.form['validity'] || true; }
    get showLabel() { return this.showEntityLabel === 'true'; }
    get newrecord() { return this.addrecord === 'true'; }
    get editMode() { return this.editable === 'true'; }
    get textOnly() { return this.showTextOnly === 'true'; }
    get detailnavigation() { return this.gotodetailpage === 'true'; }

    quickFilter = '';
    formOptions: any = {};
    model = {};
    form: FormGroup;
    formEntityFields: any = [];
    formEntityRecord: Entityrecord = new Entityrecord();

    @ViewChild('editModal') public editModal: ModalDirective;
    @ViewChild('loadingModal') public loadingModal: ModalDirective;

    notifyOptions = PlatformApp.getNotificationOptions();

    constructor(private route: ActivatedRoute, private fb: FormBuilder, private router: Router, private winRef: WindowRef,
        private _EntityApi: EntityApi, private _EntityfieldApi: EntityfieldApi,
        private _Account: AccountApi, private _EntityrecordApi: EntityrecordApi,
        private _NotificationsService: NotificationsService,
        private _LoopBackAuth: LoopBackAuth, private _EntityService: EntityService, private _CacheService: CacheService,
        private _PlatformApp: PlatformApp) {
    }

    ngOnInit(): void {
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this.form = this.fb.group({});
        this.form['subscriptions'] = [];

        this.getEntityDetails();
    }

    private getEntityDetails(): void {
        this.form['subscriptions'].push(this._EntityApi.getEntityDetails(this.entityid)
            .subscribe((response) => {
                this.entity = _.cloneDeep(response['entity']);
                this.entityDataFields = response['datafields'];
                this.entityFormFields = response['formfields'];

                if (!this.buttontext) {
                    if (this.newrecord) {
                        if (this.showLabel) {
                            this.buttontext = 'Add ' + this.entity.label;
                        } else {
                            this.buttontext = 'Add ';
                        }
                    } else if (this.editMode) {
                        if (this.showLabel) {
                            this.buttontext = 'Edit ' + this.entity.label;
                        } else {
                            this.buttontext = 'Edit ';
                        }
                    } else {
                        if (this.showLabel) {
                            this.buttontext = 'View ' + this.entity.label;
                        } else {
                            this.buttontext = 'View ';
                        }
                    }
                }
            }));
    }

    public showEditModal(): void {
        this.loadingModal.hide();
        this.loadingModal.show();
        this.hideEditModal();

        if (this.newrecord || !this.entityrecord.id) {
            this.formEntityRecord = new Entityrecord();
            if (this.parentId) { this.formEntityRecord['parentId'] = this.parentId; }
            this.formEntityFields = _.cloneDeep(this.entityFormFields);
            this._populateformfields();
            this.form['formValidity'] = true;
            this.form['viewMode'] = false;

            this.editModal.show();
            this.loadingModal.hide();
        } else if (this.editMode) {
            this.form['subscriptions'].push(this._EntityrecordApi.findByIdforEdit(this.entityrecordid)
                .subscribe((record) => {
                    if (record && record['response']) {
                        if (record['response']['record'] && record['response']['record']['data']) {
                            this.formEntityRecord = _.cloneDeep(record['response']['record']['data']);
                        }
                        if (record['response']['formfields']) {
                            this.entityFormFields = record['response']['formfields'];
                        }
                        this.formEntityFields = _.cloneDeep(this.entityFormFields);
                        this.formEntityRecord.id = this.entityrecordid;
                        this._populateformfields();
                        this.form['formValidity'] = true;
                        this.form['viewMode'] = false;

                        this.editModal.show();
                        this.loadingModal.hide();
                    } else {
                        this.notify('error', 'Record', 'Not Loaded; Please refresh');
                        console.log('ERROR - Loading Record ' + this.entityrecordid);
                    }
                }));
        } else {
            this.form['subscriptions'].push(this._EntityrecordApi.findByIdProcessed(this.entityrecordid)
                .subscribe((record) => {
                    if (record && record['response'] && record['response']['data']) {
                        this.formEntityRecord = record['response']['data'];
                        this.formEntityRecord.id = this.entityrecordid;
                        this.formEntityFields = this.makeLabels(_.cloneDeep(this.entityFormFields));
                        this._populateformfields();
                        this.form['formValidity'] = true;
                        this.form['viewMode'] = true;

                        this.editModal.show();
                        this.loadingModal.hide();
                    } else {
                        this.notify('error', 'Record', 'Not Loaded; Please refresh');
                        console.log('ERROR - Loading Record ' + this.entityrecordid);
                    }
                }));
        }
    }

    private _populateformfields() {
        this.entityFormFields.forEach(ff => {
            this._populateFormGroup(ff);
        });
    }

    private _populateFormGroup(formgroup) {
        if (formgroup.type === 'repeatedsection') {
            formgroup.templateOptions['parentmodel'] = this.formEntityRecord;
        } else if (!formgroup.type && Array.isArray(formgroup.fieldGroup) && formgroup.fieldGroup.length > 0) {
            formgroup.fieldGroup.forEach(fg => {
                this._populateFormGroup(fg);
            });
        } else if (!formgroup.type && formgroup.fieldArray
            && Array.isArray(formgroup.fieldArray.fieldGroup)
            && formgroup.fieldArray.fieldGroup.length > 0) {
            formgroup.fieldArray.fieldGroup.forEach(fg => {
                this._populateFormGroup(fg);
            });
        }
    }

    public hideEditModal(): void {
        this.editModal.hide();
        if (this.form) {
            if (this.form['subscriptions']) { this.form['subscriptions'].forEach(s => { s.unsubscribe(); }); }
            this.form = this.fb.group({});
            this.form['subscriptions'] = [];
            this.form['formValidity'] = true;
        }
    }

    private makeLabels(formfields) {
        for (let index = 0; index < formfields.length; index++) {
            if (formfields[index].fieldGroup && formfields[index].fieldGroup.length > 0) {
                this.makeLabels(formfields[index].fieldGroup);
            } else if (formfields[index].fieldArray && formfields[index].fieldArray.length > 0) {
                this.makeLabels(formfields[index].fieldArray);
            } else if (formfields[index].fieldArray
                && formfields[index].fieldArray.fieldGroup
                && formfields[index].fieldArray.fieldGroup.length > 0) {
                if (formfields[index].type === 'repeatedsection' || formfields[index].type === 'subentity') {
                    formfields[index].className = 'col-md-12';
                }
                this.makeLabels(formfields[index].fieldArray.fieldGroup);
            } else if (formfields[index].type && formfields[index].templateOptions) {
                formfields[index].type = 'input-field';
                formfields[index].templateOptions.readonly = true;
            }
        }
        return formfields;
    }

    protected deleteEntityRecord() {
        if (this.entityrecordid) {
            this.form['subscriptions'].push(this._EntityrecordApi.deleteById(this.entityrecordid).subscribe((response) => {
                if (this.entityrecord) { Object.assign(this.entityrecord, new Entityrecord()); }
                this.hideEditModal();
            }));
        }
    }

    ngOnDestroy() {
        if (this.form['subscriptions']) { this.form['subscriptions'].forEach(s => { s.unsubscribe(); }); }
    }

    protected submitRecord(entityRecord): void {
        this.formErrors = [];
        this.model = entityRecord;

        this.validateFields(this.formEntityFields);
        this.setFormErrors(this.formErrors);

        this.form['subscriptions'].push(this._EntityfieldApi.validateRecord(this.entityid, entityRecord)
            .subscribe((result) => {
                if (result && result.response && result.response.length > 0) {
                    this.form['formValidity'] = false;
                    this.setFormErrors(result.response);
                }
                if (this.form['formValidity']) {
                    this.patchOrCreateEntity(entityRecord);
                }
            }));
    }

    private validateFields(formfields) {
        for (let index = 0; index < formfields.length; index++) {
            let field = formfields[index];
            if (field.fieldGroup && field.fieldGroup.length > 0) {
                this.validateFields(field.fieldGroup);
            } else {
                if (field.expressionProperties && field.expressionProperties['templateOptions.required']) {
                    if (evalExpression(field.expressionProperties['templateOptions.required'].expression, this, [this.model])) {
                        if (!this.model[field.key]) {
                            this.formErrors.push({ 'field': field.key, 'error': 'required' });
                        }
                    }
                }
            }
        }
    }
    private setFormErrors(formErrors) {
        for (let i = 0; i < formErrors.length; i++) {
            let errorField = formErrors[i].field;
            let errorKey = formErrors[i].error;
            let error = {};
            error[errorKey] = true;
            this.form['formValidity'] = false;
            if (this.form.controls[errorField]) {
                this.form.controls[errorField].markAsTouched();
                this.form.controls[errorField].setErrors(error);
            }
        }
    }

    private patchOrCreateEntity(entityRecord): void {
        this.hideEditModal();
        this.loadingModal.show();
        // Save or Create Entity Record
        let entityRecordforSave = new Entityrecord();
        entityRecordforSave.data = entityRecord;
        entityRecordforSave.lastupdatedby = this.currentuser.id;
        entityRecordforSave.appId = this.currentuser.appId;

        //Hack to remove the appId;
        delete entityRecordforSave.data.appId;

        //Hack to update Date and Time in UI TimeZone.
        for (let i = 0; i < this.entityDataFields.length; i++) {
            if (this.entityDataFields[i].fieldtype === 'date' || this.entityDataFields[i].fieldtype === 'datetime') {
                let dateStr = PlatformApp.stringToDate(entityRecordforSave.data[this.entityDataFields[i].name], null, null);
                if (dateStr) { entityRecordforSave.data[this.entityDataFields[i].name] = dateStr; }
            }
        }


        if (!this.entityrecordid) {
            entityRecordforSave.entityId = this.entity.id;
            entityRecordforSave.createdby = this.currentuser.id;

            this.form['subscriptions'].push(this._EntityrecordApi.patchOrCreate(entityRecordforSave)
                .subscribe((newrecord: Entityrecord) => {
                    this.entityRecord = newrecord;
                    Object.assign(this.entityrecord, newrecord);
                    let label = newrecord.id;
                    if (newrecord.data && newrecord.data[this.entity['record_name']]) {
                        label = newrecord.data[this.entity['record_name']];
                    } else if (newrecord.data && newrecord.data.uniqueId) {
                        label = newrecord.data.uniqueId;
                    } else if (newrecord.data && newrecord.data.name) {
                        label = newrecord.data.name;
                    }
                    this.notify('success', 'Created ' + this.entity.label, label);
                    this.loadingModal.hide();

                    if (this.entity['open_detail_page_on_create']) {
                        this.router.navigate(['/detail/' + this.entity.id + '/' + (this.entityrecord.id || this.entityRecord.id)]);
                    }
                }));
        } else {
            this.form['subscriptions'].push(this._EntityrecordApi.patchAttributes(this.entityrecordid, entityRecordforSave)
                .subscribe((newrecord: Entityrecord) => {
                    this.entityRecord = newrecord;
                    this.setRecord(this.entityRecord);
                    Object.assign(this.entityrecord, newrecord);
                    let label = newrecord.id;
                    if (newrecord.data && newrecord.data[this.entity['record_name']]) {
                        label = newrecord.data[this.entity['record_name']];
                    } else if (newrecord.data && newrecord.data.uniqueId) {
                        label = newrecord.data.uniqueId;
                    } else if (newrecord.data && newrecord.data.name) {
                        label = newrecord.data.name;
                    }
                    this.notify('success', 'Updated ' + this.entity.label, label);
                    this.loadingModal.hide();
                }));
        }
    }

    public updateValidations(formfields) {
        for (let i = 0; i < formfields.length; i++) {
            let formField = formfields[i];
            let fieldType = formField.type;
            let fieldSubType = '';
            let validators = [];

            if (formField.templateOptions.type) {
                fieldSubType = formField.templateOptions.type;
            } else { fieldSubType = 'text'; }

            switch (fieldType) {
                case 'input-field':
                    switch (fieldSubType) {
                        case 'email':
                            validators.push(ValidationService.emailValidator);
                            break;
                        case 'phone':
                            validators.push(ValidationService.phoneValidator);
                            break;
                        case 'default':
                            break;
                    }
                    break;
                case 'geolocation':
                    validators.push(ValidationService.geolocationValidator);
                    break;
                case 'default':
                    break;
            }
            formField['validators'] = { validation: Validators.compose(validators) };

            if (this.entityrecordid && formField.key === 'parentId') {
                formField.templateOptions.disabled = true;
            }
        }
        return formfields;
    }

    setRecord(record: Entityrecord) {
        this.onChanged.emit(record);
    }

    private notify(type, title?, content?, options?) {
        if (!options) { options = PlatformApp.getNotificationOptions(); }
        if (!options.id) { options.id = type + '-' + title + '_' + content; }
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/entity-edit-button/entityrecord-edit-button.component.ts